import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../config/environment";
import { firstValueFrom } from "rxjs";
import { ImageType } from "../../database/db";

export interface UploadTicket {
  sasUri: string;
}

@Injectable({
  providedIn: "root"
})
export class UploadApiService {

  constructor(private http: HttpClient) { }

  confirmUpload(fileName: string, fileIdentifier: string, imageType: ImageType) {
    const url = `${environment.backend.apiBaseURL}/api/upload/confirm`;
    return firstValueFrom(this.http.post(url, {
      fileName,
      fileIdentifier,
      imageType
    }));
  }

  getTicket(fileName: string, fileSize: number, fileIdentifier: string, imageType: ImageType) {
    const url = `${environment.backend.apiBaseURL}/api/upload/ticket`;
    return firstValueFrom(this.http.post<UploadTicket>(url, {
      fileName,
      fileSize,
      fileIdentifier,
      imageType
    }));
  }
}